// Final 2026 event recap supplied by the event team. It keeps the public page
// useful when historical institute rows are unavailable to signed-out visitors.
export const RELAY_TEAM_IMAGE = '/images/relay-group.svg';

const archivedTeams = `Strides for strength|667150
Happy Feet :)|654787
Rizziotherapy|588808
Easier said than run|511412
Runner Beans|301355
Running Jokes|296093
Civilians|295780
Dochas|280505
UCD Actuarial & Financial Society|199672
UCD Swimming|170929
Kachow|153251
UCD Physics Society|106389
Your pace or mine|105653
UCD FILMSOC|90117
Blister sisters|88592
Dinner 🍕|75990
UCD Surf Club|75895
The Pacemakers|73626
We've got the runs|60484
Run Forrest Run|52946
The Walkie-Talkies|46140
Smiles for Miles|46101
Rithim na nGael|34402
UCD Dramsoc|27299
Belfield FM|26678
SnowsProAm|25302
UCD Juggling Society|15866
UCDC History Soc|13996
BHLS 2|13313
Horses don't stop they keep going|9717
UCD TRIATHLON CLUB|8018
The Committee|3504
123choochoo|0
BHLS Baddies|0
Bronnychogenics|0
Commerce and Economics Society|0
DMK Action in April|0
Don’t use this link|0
Don’t use this link|0
FENDS|0
Finding Chemo|0
Joavan Joggers|0
Legs Miserables|0
Lone Rangers|0
Malaysian Society|0
NAMSOC UCD|0
Nomad & Co.|0
Relay good runners|0
Scruggs' Snapped Sword & Co.|0
Shamrock group|0
The Roster|0
The Running Joke|0
UCD Canoe Club|0
UCD CU|0
UCDCU2|0
UCD Dance Soc|0
UCD Dance Society|0
UCD JSoc|0
UCD Politics & IR|0
UCD Relay for Life Committee|0
UCD Trampoline Club|0
UCD Ultimate|0
Walk for Life UCD|0
Walkie Talkies|0`
  .split('\n')
  .map((line, index) => {
    const [name, steps] = line.split('|');
    return { id: `archive-${index}`, name, steps: Number(steps), rank: index + 1, imageUrl: RELAY_TEAM_IMAGE };
  });

export const ARCHIVE_RELAY_RESULTS = {
  totalSteps: 5406312,
  athleteCount: 293,
  distanceKm: 4120,
  calories: 216252,
  teams: archivedTeams,
  athletes: [
    { id: 'cacfd507-2b50-4e6e-ac7d-302cf46d4ec2', name: 'Bernadette Harney', steps: 86566 },
    { id: '78984203-5673-4de0-9e6f-9a555e06436e', name: 'Rian Byrne', steps: 79564 },
    { id: '33637633-848a-4bd6-affd-b4d9dbdb453a', name: 'Melanie Buck', steps: 77118 },
    { id: 'ccc4ba14-c0b3-417c-992a-bb48c1917000', name: 'Orla Devlin', steps: 73978 },
    { id: '13eb4e12-4956-4c2f-a4ec-f804f03222fd', name: 'Eva Niskanen', steps: 72895 },
  ],
};

export function buildRelayResults(teamRows, memberRows, profileRows) {
  if (!teamRows?.length || !memberRows?.length) return null;

  const profileMap = new Map((profileRows || []).map(profile => [profile.id, profile]));
  const stepsByAthlete = new Map();
  const membersByTeam = new Map();

  memberRows.forEach(row => {
    if (!row.profile_id) return;
    const steps = Math.max(0, Number(row.steps) || 0);
    stepsByAthlete.set(row.profile_id, Math.max(stepsByAthlete.get(row.profile_id) || 0, steps));
    if (row.team_id) {
      if (!membersByTeam.has(row.team_id)) membersByTeam.set(row.team_id, new Map());
      const teamMembers = membersByTeam.get(row.team_id);
      teamMembers.set(row.profile_id, Math.max(teamMembers.get(row.profile_id) || 0, steps));
    }
  });

  const teams = teamRows.map(team => ({
    id: team.id,
    name: team.name,
    imageUrl: RELAY_TEAM_IMAGE,
    steps: [...(membersByTeam.get(team.id)?.values() || [])].reduce((sum, steps) => sum + steps, 0),
  })).sort((a, b) => b.steps - a.steps || a.name.localeCompare(b.name))
    .map((team, index) => ({ ...team, rank: index + 1 }));

  const athletes = [...stepsByAthlete.entries()]
    .sort((a, b) => b[1] - a[1])
    .slice(0, 12)
    .map(([id, steps]) => {
      const profile = profileMap.get(id);
      return {
        id,
        name: [profile?.name, profile?.surname].filter(Boolean).join(' ') || profile?.username || 'Relay athlete',
        steps,
        imageUrl: profile?.show_on_leaderboards === false ? '' : (profile?.profile_img || ''),
      };
    });

  const totalSteps = [...stepsByAthlete.values()].reduce((sum, steps) => sum + steps, 0);
  return {
    totalSteps,
    athleteCount: stepsByAthlete.size,
    distanceKm: Math.round(totalSteps * 0.762 / 1000),
    calories: Math.round(totalSteps * 0.04),
    teams,
    athletes,
  };
}
